export default function setSentryContext() {
  const sentryEnabled = process.env.SENTRY_ENABLED === 'true';
  if (!sentryEnabled) { return; }

  const userId = window.analyticsDataLayer.accountId;
  const { userEmail } = window.analyticsDataLayer;
  const { environment } = window.analyticsDataLayer;
  const extraContext = {
    ...window.analyticsDataLayer,
  };

  try {
    window.Sentry.configureScope((scope) => {
      Object.entries(extraContext).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
      scope.setUser({
        email: userEmail,
        id:    userId,
      });
      scope.setTag('which_sentry', 'vue');
      scope.setTag('environment', environment);
    });
  } catch {
    // proceed without additional information
  }
}
